import { render, staticRenderFns } from "./v-birth-day.vue?vue&type=template&id=494d6712&scoped=true&"
import script from "./v-birth-day.vue?vue&type=script&lang=js&"
export * from "./v-birth-day.vue?vue&type=script&lang=js&"
import style0 from "./v-birth-day.vue?vue&type=style&index=0&id=494d6712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d6712",
  null
  
)

export default component.exports